import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: '/assets/tanks',
    component: () => import('@/modules/assets/views/Tanks.vue'),
    meta: { requiresAuth: true },
  },
] as RouteRecordRaw[]
